import React, { useRef, useState, useEffect } from "react";
import { Typography, Tag, Grid, Button } from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PropertyCard from "../common/PropertyCard";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const ListingsSection = ({
  listings = [],
  title = "LATEST LISTINGS",
  totalCount = 0,
  filteredCount = 0,
  isMobile = false,
}) => {
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const screens = useBreakpoint();

  const maxVisibleCount = isMobile ? 1 : 4;
  const visibleListings = listings.slice(0, maxVisibleCount);
  const hasMoreProperties = listings.length > maxVisibleCount;

  if (!listings.length) {
    return (
      <div style={{ textAlign: "center", padding: "50px 20px" }}>
        <Title level={4} style={{ color: "#fff" }}>
          No properties found matching your filters
        </Title>
        <Text style={{ color: "#fff", opacity: 0.8 }}>
          Try adjusting your search criteria
        </Text>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "relative",
        padding: isMobile ? "20px 15px 30px 15px" : "40px 20px 50px 60px",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: isMobile ? "20px" : "30px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            flexWrap: "wrap",
          }}
        >
          <Title
            level={isMobile ? 3 : 2}
            style={{
              color: "#fff",
              margin: 0,
              fontWeight: 600,
              fontSize: isMobile ? "20px" : "32px",
              textAlign: "left",
              width: "100%",
            }}
          >
            {title}
          </Title>
        </div>
      </div>

      {/* Cards + See More */}
      <div
        style={{
          display: "flex",
          alignItems: "center", // Changed from "flex-start" to "center"
          gap: isMobile ? "10px" : "15px",
          flexDirection: "row",
          justifyContent: "flex-start",
        }}
      >
        {/* Cards Grid - Fixed 4 columns for desktop, auto width for content */}
        <div
          ref={scrollRef}
          style={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "1fr"
              : "repeat(4, minmax(280px, 1fr))",
            gap: isMobile ? "10px" : "15px",
            flex: 1,
            minHeight: isMobile ? "auto" : "350px",
            transition: "all 0.3s ease",
            justifyContent: "flex-start",
            alignContent: "start",
            width: "100%",
          }}
        >
          {visibleListings.map((property, index) => (
            <div
              key={property.id || index}
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <PropertyCard property={property} isMobile={isMobile} />
            </div>
          ))}
          {/* Add empty divs to maintain grid structure when less than 4 cards */}
          {Array.from({ length: Math.max(0, 4 - visibleListings.length) }).map(
            (_, index) => (
              <div
                key={`empty-${index}`}
                style={{
                  visibility: "hidden",
                  height: 0,
                }}
              />
            )
          )}
        </div>

        {/* See More Button - Centered vertically */}
        {hasMoreProperties && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: isMobile ? "0" : "15px",
              flexShrink: 0,
              // Removed height: "100%" and alignSelf: "stretch" since parent is now centered
            }}
          >
            <div
              onClick={() => navigate("/listed-property")}
              style={{
                width: isMobile ? "40px" : "40px",
                height: isMobile ? "40px" : "40px",
                borderRadius: "50%",
                border: "1.5px solid #fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.3s ease",
                backgroundColor: "transparent",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)";
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <RightOutlined
                style={{
                  fontSize: isMobile ? "16px" : "20px",
                  color: "#fff",
                  fontWeight: "bold",
                }}
              />
            </div>
            <Text
              onClick={() => navigate("/listed-property")}
              style={{
                color: "#fff",
                marginTop: "8px",
                fontSize: isMobile ? "12px" : "14px",
                cursor: "pointer",
                transition: "color 0.3s",
                fontWeight: 500,
                textAlign: "center",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#ccc")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#fff")}
            >
              See More
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListingsSection;
